module.exports = __webpack_public_path__ + "img/arrow-right-down.8cd74703.svg";